import { useAdvisorAccess } from '../../../../../hooks/useAdvisorAccess'
import { useAdvisorLayerModeContext } from '../contexts/advisorLayerModeContext'
import { AdvisorLayerMode } from '../enums/advisorLayerMode'

export const useIsAdvisorExpertLayer = (): boolean => {
  const { shouldShowToggle } = useAdvisorAccess()
  const { mode } = useAdvisorLayerModeContext()

  return shouldShowToggle && mode === AdvisorLayerMode.Expert
}
